import React, { useContext, useEffect, useState } from 'react'
import axios from '../../../adapters/API/axios';
import AuthContext from '../../../auth/Context/AuthContext';
import { Col, Modal, Row, Spinner } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';
import LocationMarker from '../../MapsReader';

function ModalDetailLokasiAbsen({
    rowSelected,
    showDetailLokasiAbsen,
    setShowDetailLokasiAbsen
}) {

    const { tokens } = useContext(AuthContext);
    const tokenUser = tokens?.token;
    const [detailAbsenMasuk, setDetailAbsenMasuk] = useState();
    const [detailLokasiMasuk, setDetailLokasiMasuk] = useState();
    const [detailAbsenKeluar, setDetailAbsenKeluar] = useState();
    const [detailLokasiKeluar, setDetailLokasiKeluar] = useState();
    const [loading, setLoading] = useState(true);

    const navigate = useNavigate();

    const fetchListAdetailAbsenMasuk = () => {
        setLoading(true);
        const startTime = Date.now(); // Track start time
        axios.get(`/api/checkin_detail/${rowSelected?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {
                setDetailAbsenMasuk(res.data)
                const [longitude, latitude] = res.data.checkin_location
                    .match(/POINT \(([-0-9.]+) ([-0-9.]+)\)/)
                    .slice(1)
                    .map(Number);
                setDetailLokasiMasuk({ longitude, latitude });

                // Ensure loading lasts at least 2 seconds
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => setLoading(false), delay);

            }).catch(err => {
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => {
                    setLoading(false);
                    if (err.response?.status === 401) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                            confirmButtonText: 'Login',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate('/');
                            }
                        });

                    } else (console.log(err))
                }, delay);
            })
    };

    const fetchListAdetailAbsenKeluar = () => {
        setLoading(true);
        const startTime = Date.now(); // Track start time
        axios.get(`/api/checkout_detail/${rowSelected?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setDetailAbsenKeluar(res.data)
                const [longitude, latitude] = res.data.checkout_location
                    .match(/POINT \(([-0-9.]+) ([-0-9.]+)\)/)
                    .slice(1)
                    .map(Number);
                setDetailLokasiKeluar({ longitude, latitude });

                // Ensure loading lasts at least 2 seconds
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => setLoading(false), delay);

            }).catch(err => {
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => {
                    setLoading(false);
                    if (err.response?.status === 401) {
                        Swal.fire({
                            icon: 'error',
                            title: 'Oops...',
                            text: 'Sesi Anda telah berakhir. Silahkan Login kembali.',
                            confirmButtonText: 'Login',
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate('/');
                            }
                        });
                    } else (console.log(err))
                }, delay);
            })
    };


    useEffect(() => {
        const fetchData = async () => {
            if (rowSelected?.id !== undefined && tokenUser !== undefined) {

                await fetchListAdetailAbsenMasuk();
                await fetchListAdetailAbsenKeluar();
            }
        };

        fetchData();
    }, [rowSelected?.id, tokenUser]);

    const handleCloseModal = () => {
        setShowDetailLokasiAbsen(false);

        setDetailAbsenMasuk();
        setDetailAbsenKeluar();
        setDetailLokasiMasuk();
        setDetailLokasiKeluar();
    };

    // console.log(detailLokasiMasuk)

    return (
        <Modal
            show={showDetailLokasiAbsen}
            onHide={handleCloseModal}
            backdrop="static"
            keyboard={false}
            centered
            size='xl'
        >
            <Modal.Header closeButton>
                <Modal.Title style={{ fontFamily: 'Poppins-Medium' }}>
                    Detail Lokasi
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Row>
                    <Col style={{ borderRight: 'solid 1px' }}>
                        <p className='text-start' style={{ fontFamily: 'Poppins-Regular', fontSize: '19px' }}>Absen Masuk</p>

                        <div>
                            <p className='text-modal'>Lokasi: {detailAbsenMasuk?.checkin_place}</p>
                            <p className='text-modal'>Waktu: {detailAbsenMasuk?.checkin_time.split('T')[0]} {detailAbsenMasuk?.checkin_time.split('T')[1].split('.')[0]}</p>
                            <p className='text-modal'>Keterlambatan: {detailAbsenMasuk?.late_duration}</p>
                        </div>

                    </Col>
                    <Col style={{ borderLeft: 'solid 1px' }}>
                        <p className='text-end' style={{ fontFamily: 'Poppins-Regular', fontSize: '19px' }}>Absen Pulang</p>
                        <div>
                            {detailAbsenKeluar ?
                                (
                                    <>
                                        <p className='text-modal  text-end'>Lokasi: {detailAbsenKeluar?.checkout_place}</p>
                                        <p className='text-modal  text-end'>Waktu: {detailAbsenKeluar?.checkout_time.split('T')[0]} {detailAbsenKeluar?.checkout_time.split('T')[1].split('.')[0]}</p>
                                        <p className='text-modal  text-end'>Pulang Awal: {detailAbsenKeluar?.early_duration}</p>
                                        <p className='text-modal  text-end'>Lembur: {detailAbsenKeluar?.overtime_duration}</p>
                                    </>
                                )
                                :
                                (
                                    <>
                                        <p className='text-modal  text-end'>User Tidak/Belum melakukan Absen Pulang</p>
                                    </>
                                )
                            }
                        </div>
                    </Col>
                </Row>
                <Row className='mt-4'>
                    {loading && (
                        <div>
                            <div className='text-center'>
                                <Spinner animation="border" size='lg' className='my-4' style={{ color: '#000A2E' }} />
                            </div>

                        </div>
                    )}
                    {!loading && (

                        <LocationMarker lokasiMasuk={detailLokasiMasuk} lokasiPulang={detailLokasiKeluar} />
                    )}
                </Row>

                <div className='mt-1'>
                    <p style={{ fontFamily: 'Poppins-Regular', color: 'green', marginBottom: '0px', fontSize: '14px' }}>*Marker hijau: Absen Masuk</p>
                    <p style={{ fontFamily: 'Poppins-Regular', color: 'red', marginBottom: '0px', fontSize: '14px' }}>*Marker merah: Absen Pulang</p>
                </div>
            </Modal.Body>
        </Modal>
    )
}

export default ModalDetailLokasiAbsen
